/* src/app/interview2-question/interview2-question.component.scss */
.content-pading {
  padding-left: 12.5%;
}
.interview-counter,
.interview-title {
  display: inline-block;
}
.interview-counter {
  margin-left: 20px;
}
h4.example {
  font-size: 1.75rem;
  margin: 28px 0 4px 0;
}
.read-more-link {
  cursor: pointer;
  margin-top: 15px;
  text-decoration: underline;
  display: inline-block;
  font-size: 1.286rem;
  line-height: 1.5;
  letter-spacing: 0.5px;
}
div.full-bg-cover {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translateX(-50%) translateY(-50%);
  background-color: #272A33;
}
.content-container {
  position: relative;
  max-width: 1040px;
  margin: auto;
}
.content-container .options-container {
  display: flex !important;
  width: 100%;
}
.content-container h2 {
  max-width: 816px;
  margin: 0 auto;
  padding: 0;
  font-family: "Campton-SemiBold";
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 1px;
  color: #ffffff;
  border: 1px solid red;
}
.distaction-question-type-1 .content-container .list-group {
  margin: 4% auto 0 auto;
}
.distaction-question-type-2 .content-container .list-group {
  margin: 1.25% auto 0 auto;
}
.distaction-question-type-3 .content-container .list-group {
  margin: 4.5% auto 0 auto;
}
.distaction-question-type-4 .content-container .list-group {
  margin: 4% auto 0 auto;
}
.list-group {
  float: left;
  display: block;
}
.list-group-item {
  float: left;
  transform: translateY(-50%);
  top: 50%;
  padding: 0;
  margin: 0;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
}
.distaction-question-type-4 .list-group-item .image-option,
.distaction-question-type-3 .list-group-item .image-option {
  margin: 10px;
}
.distaction-question-type-4 .list-group-item label,
.distaction-question-type-3 .list-group-item label {
  margin-top: 15%;
}
.list-group-item {
  font-family: "Campton-SemiBold", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 2px;
  text-align: center;
  color: #ffffff;
  margin-right: 70px;
  min-height: 95px;
}
.list-group-item:last-of-type {
  margin-right: 0;
}
.option-button {
  background-color: rgba(255, 255, 255, 0.1);
  min-width: 300px;
  height: 60px;
  border-radius: 50px;
  border: solid 4px transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  color: #ffffff;
  text-transform: uppercase;
}
.option-button:hover,
.list-group-item.selected .option-button {
  border: 4px solid #ffffff;
}
.list-group-item .option-indicator {
  display: block;
  visibility: hidden;
  margin-top: 5px;
}
.list-group-item.selected .option-button.correct,
.list-group-item.selected .image-option.correct {
  border: solid 4px #6ccc09;
}
.list-group-item.selected .option-button.wrong,
.list-group-item.selected .image-option.wrong {
  border: solid 4px #ff495c;
}
.list-group-item.selected .option-indicator {
  visibility: visible;
  opacity: 1;
}
.btn-outline-primary {
  margin-top: 5%;
  visibility: hidden;
  -webkit-transition: opacity 0ms ease-in-out;
  -moz-transition: opacity 0ms ease-in-out;
  -o-transition: opacity 0ms ease-in-out;
  transition: opacity 0ms ease-in-out;
}
.btn-outline-primary.show {
  visibility: visible;
}
.main-image-container img {
  margin-top: 4%;
  width: 20%;
  height: 30%;
}
.distaction-question-type-4 .main-image-container img {
  margin-top: 4%;
  width: auto;
}
.image-option {
  background-size: 110%;
  border-radius: 100%;
  border: solid 4px transparent;
  cursor: pointer;
  width: 176px;
  height: 176px;
  background-color: transparent;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
  background-repeat: no-repeat;
  background-position: center;
}
p.question {
  font-size: 33px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: 1px;
  text-align: left;
  margin-bottom: 25px;
}
div.explanation {
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: 1px;
  color: #ffffff;
  text-align: left;
  margin-bottom: 20px;
  min-height: 165px;
  max-height: 230px;
  overflow: hidden;
  overflow-y: auto;
}
@media only screen and (max-width: 1060px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .option-button {
    min-width: 250px;
    height: 50px;
    font-size: 18px;
  }
  .content-container {
    padding: 0 20px 0 20px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .option-button {
    min-width: 170px;
    font-size: 15px;
  }
}
@media only screen and (max-height: 768px) {
  #nextD {
    margin-bottom: 5%;
  }
}
/*# sourceMappingURL=interview2-question.component.css.map */
